module.exports = __webpack_public_path__ + "a8314ab7a97624ccc396d838900676f2.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/155.png
// module id = 1750
// module chunks = 2